var map = {
	"./ViniAnnataW255.png": 4966,
	"./ViniBianchiW255.png": 51743,
	"./ViniBioW255.png": 71597,
	"./ViniDessertW255.png": 7413,
	"./ViniDolciW255.png": 60514,
	"./ViniNaturaliW255.png": 45937,
	"./ViniRoseW255.png": 24632,
	"./ViniRossiW255.png": 98707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18175;